let expandableContentLabel = 'Expand';

const EXPAND_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 14L12 9L17 14" stroke="#111" stroke-width="2"/></svg>'
)}`;
const RESET_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 10L12 15L17 10" stroke="#111" stroke-width="2"/></svg>'
)}`;

export const getExpandButtonContainerElement = (
  domContainer: HTMLElement,
  containerToExpand: HTMLElement,
  ariaControlsId: string
) => {
  const onExpandCallback = (button: HTMLButtonElement) => {
    /* eslint-disable no-param-reassign */
    const className = 'oc-expandable-content__expanded';
    const icon = button.querySelector('img') as HTMLImageElement;
    if (containerToExpand.classList.contains(className)) {
      containerToExpand.classList.remove(className);
      containerToExpand.style.position = 'relative';
      icon.src = EXPAND_SVG;
      button.setAttribute('aria-expanded', 'false');
    } else {
      containerToExpand.classList.add(className);
      containerToExpand.style.position = 'fixed';
      icon.src = RESET_SVG;
      button.setAttribute('aria-expanded', 'true');
    }
  };

  const labelProp = (domContainer as any)?.dataset?.expandableContentLabel;
  if (labelProp) expandableContentLabel = labelProp;

  const expandButtonContainer = document.createElement('div');
  expandButtonContainer.classList.add('oc-expandable-content');

  const label = document.createElement('span');
  label.classList.add('oc-expandable-content__button-label');
  label.innerHTML = expandableContentLabel;

  const button = document.createElement('button');
  button.classList.add('oc-expandable-content__button');
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', ariaControlsId);

  const icon = document.createElement('img');
  icon.src = EXPAND_SVG;

  button.addEventListener('click', () => onExpandCallback(button));
  button.appendChild(icon);

  expandButtonContainer.appendChild(label);
  expandButtonContainer.appendChild(button);

  return expandButtonContainer;
};

export const init = (
  domContainer: HTMLElement,
  containerToExpand: HTMLElement,
  ariaControlsId: string
) => {
  const expandButtonContainer = getExpandButtonContainerElement(
    domContainer,
    containerToExpand,
    ariaControlsId
  );
  containerToExpand.insertBefore(expandButtonContainer, containerToExpand.firstChild);
};

export default { init, getExpandButtonContainerElement };
